import French from './lang/fr.json';
import English from './lang/en.json';
import { useIntl } from 'react-intl';
import { LikiLink } from './components';

export const locales = { 
    fr: { messages: French }, 
    en: { messages: English } 
};

export const RouteNames = {
    Welcome: "welcome",
    Signup: "signup",
    Faq: "faq"
}

export const translatedPath = (path, lang) => {
    return locales[lang].messages["routes." + path];
}

export const TranslatedLink = ({ to, children, ...props }) => {
    const { locale } = useIntl();
    let navPath = `/${locale}`;
    if (to) {
        navPath += `/${translatedPath(to, locale)}`;
    }

    return (
        <LikiLink {...props} to={navPath}>
            {children}
        </LikiLink>
    )
}

export const ExternalLink = ({ to, children, ...props }) => {
    const intl = useIntl();

    const url = intl.messages["external." + to];

    return (
        <LikiLink {...props} to={url}>
            {children}
        </LikiLink>
    )
}
